import { Component } from 'react';
import PropTypes from 'prop-types';

class ButtonComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(e) {
    this.props.onClickHandler(e);
  }

  render() {
    const {
      id,
      name,
      title,
      label,
      value,
      className,
      inputClassNames,
      showLabel,
      disabled,
    } = this.props;

    return (
      <div className={className}>
        <button
          value={this.props.value}
          name={name}
          title={title}
          id={id}
          type="button"
          onClick={this.onClickHandler}
          className={inputClassNames}
          disabled={disabled}
        >
          {value}
        </button>
        {!showLabel ? '' :
          <label htmlFor={id}>{label}</label>
        }
      </div>
    );
  }
}

ButtonComponent.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  inputClassNames: PropTypes.string,
  onClickHandler: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  showLabel: PropTypes.bool,
  disabled: PropTypes.bool,
};

ButtonComponent.defaultProps = {
  className: 'input',
  inputClassNames: null,
  id: null,
  label: null,
  title: null,
  value: '',
  onClickHandler: () => {},
  showLabel: true,
  disabled: false,
};

export default ButtonComponent;
